import React from "react";

export default class Icons extends React.Component {
  constructor(props) {
    super(props);

    this.state = {

    };
  }

  render() {
    return (
      <>

      </>
    )
  }

}
